import axios from "axios";
import { host } from "./utilities";

axios.defaults.withCredentials = true;
export const assetServiceHealthCheckAxios = () => (config) => axios.get(`${host()}/health-check`, config);
